import React, { Component } from 'react'
import { 
    Alert,
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    FormGroup,
    Input,
    Label,
    Row
} from 'reactstrap'
import Async from 'react-select/async';
import Datetime from "react-datetime";

// Requests
import { getClientsRequest } from 'api/client';
import { getUsersRequest } from 'api/user';
import { updateClientActionRequest } from 'api/clientActions';
import { createClientActionRequest } from 'api/clientActions';
import { getClientActionRequest } from 'api/clientActions';
// Constants
import { clientActionsStatuses } from '../../constants';
// Helpers
import { formatClientActionsStatus } from 'helpers/status';
import moment from 'moment';

class ClientActionsForm extends Component {
    constructor(props) {
		super(props);
		this.state = {
			clientAction: {},
			error: null,
			saving: false,
            filtersClients: {},
            filtersOwner: {},
            alert: null,
            selectedStatus: ''
		}
		this.timeout = null;
	}

    async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

        if (id) {
			try {
				const clientAction = await getClientActionRequest(id);

                if(clientAction.client) {
					clientAction.selectedClient = {
						label: `${clientAction.client.first_name} ${clientAction.client.last_name}`,
						value: clientAction.client._id
					};
				}

                if(clientAction.owner) {
					clientAction.selectedOwner = {
						label: `${clientAction.owner.first_name} ${clientAction.owner.last_name}`,
						value: clientAction.owner._id
					};
				}
				this.setState({ clientAction })
			} catch(err) {
				this.setState({
					error: err.message || 'There was an error fetching clientAction'
				});
			}
        }
    }

    goTo = path => this.props.history.push(path);

    loadClients = async (search, callback) => {
		const { filtersClients } = this.state;
		this.setState({
			filtersClients: {
				...filtersClients,
				search
			}
		})
		if(search) {
			const clientResponse = await getClientsRequest(filtersClients);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

    loadUsers = async (search, callback) => {
		const { filtersOwner } = this.state;

		this.setState({
			filtersOwner: {
				...filtersOwner,
				search
			}
		})
		if(search) {
            const userResponse = await getUsersRequest(filtersOwner);
			const users = userResponse.users.map(user => {
				return {
					data: user,
					label: `${user.first_name} ${user.last_name}`,
					value: user._id
				}
			})
			callback(users);
		}
	}

    onChangeAsyncSelect = (key) => (object) => {
        const { clientAction } = this.state;
        let keySelect; 

        switch(key) {
            case 'client':
                keySelect = 'selectedClient'
            break;
            case 'owner':
                keySelect = 'selectedOwner'
            break;
            default: keySelect = ''
        }

		if(!object) {
            this.setState({
                clientAction: {
                    ...clientAction, 
                    [key]: "",
                    [keySelect]: ''
                },
            })
            return;
        }

		this.setState({
			clientAction: {  
                ...clientAction,
                [key]: object.value,
                [keySelect]: object
            },
		})
    }

    onChangeField = (e) => {
		const { target } = e;
		const { name, value } = target;
		this.setState(prevState => ({
			clientAction: {
				...prevState.clientAction,
				[name]: value,
			},
		}));
	}

    onSelectChange = (key) => (object) => {
        const { value } = object.target
		this.setState(prevState => ({
			clientAction: {
				...prevState.clientAction,
				[key]: value,
			},
            ...(key === 'status' &&  {
                selectedStatus: value
            })
		}));
	}

    save = async () => {
		this.setState({
			saving: true
		})

		const { clientAction } = this.state;
		const { _id } = clientAction;

		try {
	        if (_id) {
				await updateClientActionRequest(clientAction);
			} else {
				await createClientActionRequest(clientAction);
			}
			this.setState({
				saving: false
			})
			this.goTo('/client-actions');
		} catch (err) {
			this.setState({
				error: err.message || "There was an error saving Client Action",
				saving: false
			})
		}
	
	}

    render () {
        const {
            error,
            clientAction,
            saving,
            selectedStatus
        } = this.state;
        
        const {
            _id,
            recommendation,
            selectedClient,
            selectedOwner,
            justification,
            status,
            dateRequested,
            blockNumber,
            lotNumber,
            createdAt,
            updatedAt
        } = clientAction || {};

        return (
            <>
                <div className='content'>
                    <Row>
						<Col md="12">
							<Card>
								<CardHeader className="mb-5">
									<CardTitle tag="h3">
										Client Action
                                        <Button
                                            className="float-right"
                                            color="default"
                                            onClick={() => this.goTo('/client-actions')}
                                        >
                                            Back
                                        </Button>
                  					</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md='12'>
                                            <FormGroup>
                                                    <Label>Client <span className="required-start">*</span></Label>
                                                    <Async
                                                        clearValue={""}
                                                        value={selectedClient}
                                                        name="client"
                                                        options={[]}
                                                        loadOptions={this.loadClients}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        onChange={this.onChangeAsyncSelect('client')}
                                                        placeholder="Client..."
                                                        isClearable={true}
                                                    />
                                            </FormGroup>
                                        </Col>
                                        <Col md='12'>
                                            <FormGroup>
                                                <Label>Block Number</Label>
                                                <Input
                                                    type="text"
                                                    name="blockNumber"
                                                    value={blockNumber}
                                                    onChange={this.onChangeField}
                                                    className="p-2"
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Lot Number</Label>
                                                <Input
                                                    type="text"
                                                    name="lotNumber"
                                                    value={lotNumber}
                                                    onChange={this.onChangeField}
                                                    className="p-2"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md='12'>
                                            <FormGroup>
                                                    <Label>Processed by <span className="required-start">*</span></Label>
                                                    <Async
                                                        clearValue={""}
                                                        value={selectedOwner}
                                                        name="owner"
                                                        options={[]}
                                                        loadOptions={this.loadUsers}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        onChange={this.onChangeAsyncSelect('owner')}
                                                        placeholder="Owner..."
                                                        isClearable={true}
                                                    />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Label>Date Requested</Label>
										    <Datetime
										    	inputProps={{
										    		className: "form-control",
										    		placeholder: "Date Requested",
										    		name: "dateRequested"
										    	}}
										    	dateFormat="MM/DD/YYYY"
										    	timeFormat={false}
										    	value={typeof dateRequested === 'string' ? moment(dateRequested).format("MM/DD/YYYY") : dateRequested}
										    	onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "dateRequested" }})}
										    	closeOnSelect={true}
										    />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='mt-2'>
                                            <Label>Request <span className="required-start">*</span></Label>
                                            <Input
                                                type="textarea"
                                                name="request"
                                                value={clientAction.request || ''}
                                                onChange={this.onChangeField}
                                                className="p-2"
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='mt-2'>
                                            <Label>Details <span className="required-start">*</span></Label>
											<Input
												type="textarea"
												name="justification"
												value={justification}
												onChange={this.onChangeField}
                                                className="p-2"
											/>
                                        </Col>
                                    </Row>
                                    
                                    { _id &&
                                        <>
                                            <Row>
                                                <Col className='mt-2'>
                                                    <Label>Recommendation</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="recommendation"
                                                        value={recommendation}
                                                        onChange={this.onChangeField}
                                                        className="p-2"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-2'>
                                                    <Label>Status</Label>
                                                    <Input
                                                        type="select"
                                                        className="basic-multi-select"
                                                        name="status"
                                                        onChange={this.onSelectChange('status')}
                                                        value={status}
                                                    >
                                                        <option value=''>--SELECT--</option>
                                                        {clientActionsStatuses.map((status) => {
                                                                return (
                                                                    <option key={status} value={status}>{formatClientActionsStatus(status)}</option>
                                                                )
                                                            })}
                                                    </Input>
                                                    { selectedStatus === 'completed' && 
                                                        <Alert color="warning" className="mt-2" fade={false}>
                                                            Warning: Please use the "Mark as Completed" modal 
                                                            instead of setting the status as "completed" directly on this page.
                                                        </Alert>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={6}>
                                                    <FormGroup>
                                                        <Label>Created at</Label>
                                                        <Input
                                                            type="text"
                                                            name="create_at"
                                                            value={createdAt || ''} 
                                                            disabled
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col sm={12} md={6}>
                                                    <FormGroup>
                                                        <Label>Updated at <span className="required-start">*</span></Label>
                                                        <Input
                                                            type="text"
                                                            name="update_at"
                                                            value={updatedAt || ''} 
                                                            disabled
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                </CardBody>
                                {error ? 
                                    <div className="alert alert-danger m-3 mt-0">
                                        <span>{error}</span>
                                    </div> 
                                : null
                                }
                                <Col>
                                    <Button color="primary" block={false} className="mb-4" onClick={this.save} disabled={saving}>
                                        {saving
                                            ? "Saving..."
                                            : _id
                                                ? "Save Changes"
                                                : "Save Client Action"
                                        }
                                    </Button>
                                </Col>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        )
    }
}

export default ClientActionsForm